<template>
  <div
    ref="cardWrapper"
    :data-prodid="item.prodID"
    :data-master-style="item.master_style"
    :data-style="item.style"
    :data-name="item.datamann_desc"
    :data-category="item.productType"
    :data-price="item.pricing.min_discount_price"
    :data-list="listName"
    :data-position="index"
    class="hit media">
    <meta
      itemprop="brand"
      content="Julianna Rae">
    <meta
      :content="item.style"
      itemprop="mpn">
    <div class="image-container">
      <div v-if="false && onSale" class="ribbon"><span class="brand">On Sale</span></div>
      <a
        :href="targetUrl"
        class="href-color-adjust"
        itemprop="url"
        @click="onProductClick" >
        <img
          ref="mainImage"
          :src="imageSrc"
          :alt="item.mainImage_alttag"
          loading="lazy"
          width="292"
          height="411"
          itemprop="image">
      </a>
      <div
        v-if="item.pinterestUrl"
        class="pinterest pinterest-small">
        <a
          :href="'https://www.pinterest.com/pin/create/button/?' + item.pinterestUrl"
          target="_blank"
          rel="noopener">
          <svg><use xlink:href="#pinterest"/></svg>
        </a>
      </div>
    </div>
    <div class="media-body">
      <a
        :href="targetUrl"
        class="href-color-adjust"
        @click="onProductClick">
        <div class="pull-left">
          <h4 class="hit_name">
            <span
              itemprop="name"
              v-html="item.name || item.datamann_desc"/>
            <span v-if="newStyle" class="badge silver">New</span>
            <span v-if="newColors" class="badge silver">New Colors</span>
          </h4>
          <div
            v-if="item.alsoPetite"
            class="also-petite">Also in: Petite</div>
          <div
            v-if="item.alsoRegular"
            class="also-petite">Also in: Regular</div>
        </div>
        <product-price
            class="product-price pull-right text-right"
            :has-sale-price="item.hasSalePrice"
            :pricing="item.pricing">
          <star-rating
              :total-reviews="item.total_reviews"
              :average-score="item.average_score"/>
        </product-price>
        <div class="clearfix"/>
      </a>
      <div v-html="item.description"/>
      <color-count :count="item.colors.length" :sale-count="saleColorCount"/>
      <swatch-list
        v-if="!noColors"
        :colors="item.colors"
        :product-url="item.url"
        :sale-only="saleOnly"
        :lazy="false"
        @changeSwatch="changeSwatch"/>
    </div>
    <div
      itemprop="offers"
      itemscope
      itemtype="http://schema.org/Offer">
      <meta
        :content="item.pricing.min_discount_price"
        itemprop="price">
      <meta
        itemprop="priceCurrency"
        content="USD">
      <meta
        itemprop="availability"
        content="http://schema.org/InStock">
      <meta
        itemprop="itemCondition"
        content="http://schema.org/NewCondition">
    </div>
  </div>
</template>

<style scoped>
.hit {
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #EEE;
}
.hit_price {
    margin-top: 0;
    margin-left: 20px;
}
.hit_name {
    margin-top: 0
}
.sale-price {
  margin-left: 15px;
}
.image-container {
  position: relative;
  float: left;
  width: 20%;
}
/*
.image-container a {
  display:inline-block;
  width:20%;
}
*/
.image-container a > img {
  display: block;
  max-width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
.media-body {
  padding-left: 10px;
}
.hit a {
  color: black;
}
</style>

<script>
import SwatchList from './SwatchList'
import StarRating from './StarRating'
import ProductPrice from './ProductPrice'
import { handleProductClick } from '../../module/util'
import ColorCount from "./ColorCount"

export default {
  components: {
    'color-count': ColorCount,
    'swatch-list': SwatchList,
    'star-rating': StarRating,
      'product-price': ProductPrice,
  },

    props: {
        item: {
            type: Object,
            default: null
        },
        listName: {
          type: String,
          default: null
        },
        index: {
            type: Number,
            default: null
        },
        noColors: {
            type: String,
            default: null
        },
        saleOnly: {
            type: Boolean,
            default: false
        },
    },

    data () {
        return {
            onSale: this.item ? this.item.on_sale : false,
            newStyle: this.item ? this.item.new_style : false,
            newColors: this.item ? this.item.new_colors && !this.item.new_style : false,
            imageSrc: this.item ? this.item.listingImageUrl : null,
            targetUrl: this.item ? this.item.url + this.item.urlSelector : null,
        }
    },

    methods: {
        onProductClick () {
            handleProductClick()
        },
        changeSwatch (data) {
            this.imageSrc = data.imageSrc
            this.targetUrl = data.targetUrl
            this.onSale = data.onSale
        },
    },

    computed: {
      saleColorCount () {
          // TODO - support sale color count in search results
          return this.item.saleColors ? this.item.saleColors.length : 0
      }
    },
}
</script>
